import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

const useFooterLinks = () => {
  const { i18n } = useTranslation();

  const footerLinks = useMemo(() => {
    if (typeof showConsentPreferencesPopup !== 'function') return [];
    const cookiesPreferencesLabel = i18n.language?.startsWith('fr') ? 'Préférence de témoins' : 'Cookies preference';
    return [{ text: cookiesPreferencesLabel, onClick: () => { showConsentPreferencesPopup(); } }];
  }, [i18n.language]);

  return footerLinks;
};

export default useFooterLinks;
